function getTimeOfflineText(timeOffline: string) {
    const data1: any = new Date(timeOffline);
    const data2: any = new Date();

    const diferencaMinutos = Math.floor((data2 - data1) / (1000 * 60)) % 60;
    const diferencaHoras = Math.floor((data2 - data1) / (1000 * 60 * 60)) % 24;
    const diferencaDias = Math.floor((data2 - data1) / (1000 * 60 * 60 * 24));

    if (diferencaMinutos == 0 && diferencaHoras == 0 && diferencaDias == 0) {
        return 'Agora mesmo';
    }

    let tempoOffline = '';

    if (diferencaDias > 0) {
        tempoOffline += `${diferencaDias}d, `;
    }

    if (diferencaHoras > 0) {
        tempoOffline += `${diferencaHoras}h e `;
    }

    if (tempoOffline == '') {
        tempoOffline = `${diferencaMinutos} min`;
    } else {
        tempoOffline += `${diferencaMinutos}m`;
    }

    return tempoOffline;
}

function formatDateToBrazilian(time: number) {
    if (!time) {
        return;
    }

    const options: any = {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'America/Sao_Paulo',
    };

    const formattedDate = new Date(time).toLocaleString('pt-BR', options);
    return formattedDate;
}

export { formatDateToBrazilian,getTimeOfflineText };